module.exports = __webpack_public_path__ + "static/media/Asset 56.729103ee.jpg";